module.exports = __webpack_public_path__ + "static/media/address6.a3de2562.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/busnorte/favoriteDestinations/address6.png
// module id = 1834
// module chunks = 0